// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-tooltip .ant-tooltip-arrow::after,
.ant-tooltip .ant-tooltip-inner {
    background-color: #323A45 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/globalStyles.css"],"names":[],"mappings":"AAAA;;IAEI,oCAAoC;AACxC","sourcesContent":[".ant-tooltip .ant-tooltip-arrow::after,\n.ant-tooltip .ant-tooltip-inner {\n    background-color: #323A45 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
